import { cssVar } from '@savgroup-front-common/primitive/helpers/cssVar';

export const APP_BOTTOM_BAR_HEIGHT_PROPERTY = '--app-bottom-bar-height';

export const APP_BOTTOM_BAR_HEIGHT = cssVar(
  APP_BOTTOM_BAR_HEIGHT_PROPERTY,
  '0px',
);

export const APP_BOTTOM_BAR_HEIGHT_PADDING_CLASS =
  'pb-(--app-bottom-bar-height)';
